<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        Customer Satisfaction
                    </h2>
                    <div class="page-url">
                        <a routerLink="/" class="old-page">Home </a> /
                        <p>Customer Satisfaction</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->

    <!-- =============News & Events========== -->
    <section>
        <div class="latest-blog cpy-8">
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-8 col-md-8 col-sm-10">
                            <div class="sec-head">
                                <h2 class="mb-2">Customer Satisfaction</h2>
                                <p>
                                    At <span class="fw-bold theme-color">Prism Textile Machinery</span>, customer
                                    satisfaction is at the heart of everything we
                                    do, We aim to continuously improve our products and customer experience. Your
                                    insights will help us ensure that our weaving, dyeing, and finishing machines meet
                                    your expectations in terms of performance, reliability, and service quality.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center mt-4 pt-5">
                    <div class="col-lg-10 col-md-10 col-sm-12 col-12">
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4" *ngFor="let satisfaction of customerSatisfactionList; let i = index;">
                                <a [href]="satisfaction?.pdf" target="_blank">
                                    <div class="pdf-box text-center">
                                        <div class="pdf-header-content">
                                            <p class="m-0 font-14">{{ satisfaction.title }}</p>
                                        </div>
                                        <div class="pdf-body-content">
                                            <img src="assets/img/pdf-satisfaction.png" alt="" class="img-fluid pdf-img">
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>